import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowUp, Instagram, Facebook, Youtube, Linkedin } from "lucide-react";
import { WHATSAPP, SOCIAL_LINKS } from "@/lib/site";

export const WhatsAppButton = () => (
  <a
    href={WHATSAPP.link}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="whatsapp-float-button"
    aria-label="Chat with ASAI on WhatsApp"
    className="fixed bottom-6 right-6 z-50 inline-flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_10px_30px_-6px_rgba(37,211,102,0.6)] animate-pulse-glow transition-transform duration-300 hover:scale-110"
  >
    <svg viewBox="0 0 24 24" className="h-7 w-7" fill="currentColor" aria-hidden="true">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51l-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347zM12.05 21.785h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884a9.82 9.82 0 016.988 2.898 9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.884 9.884zm8.413-18.297A11.815 11.815 0 0012.05.001C5.495.001.16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.304-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
    </svg>
  </a>
);

const SOCIAL_ITEMS = [
  { label: "Instagram", href: SOCIAL_LINKS.instagram, Icon: Instagram },
  { label: "Facebook", href: SOCIAL_LINKS.facebook, Icon: Facebook },
  { label: "YouTube", href: SOCIAL_LINKS.youtube, Icon: Youtube },
  { label: "LinkedIn", href: SOCIAL_LINKS.linkedin, Icon: Linkedin },
];

export const SocialFloatingMenu = () => {
  return (
    <div
      data-testid="social-float-menu"
      className="fixed right-3 top-1/2 z-40 flex -translate-y-1/2 flex-col gap-1.5 sm:right-4 sm:gap-2"
    >
      {SOCIAL_ITEMS.map((item) => {
        const { Icon } = item;
        return (
          <a
            key={item.label}
            href={item.href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={item.label}
            title={item.label}
            data-testid={`social-float-${item.label.toLowerCase()}`}
            className="group relative inline-flex h-9 w-9 items-center justify-center rounded-full bg-white text-navy shadow-md ring-1 ring-navy/10 transition-all duration-300 hover:text-orange hover:ring-2 hover:ring-orange/50 sm:h-10 sm:w-10"
          >
            <Icon className="h-[18px] w-[18px] sm:h-5 sm:w-5" />
            <span className="pointer-events-none absolute right-full mr-2.5 whitespace-nowrap rounded-md bg-navy px-2.5 py-1 text-xs font-medium text-white opacity-0 shadow-md transition-opacity duration-200 group-hover:opacity-100">
              {item.label}
            </span>
          </a>
        );
      })}
    </div>
  );
};

export const ScrollToTopButton = () => {  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 500);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.button
          data-testid="scroll-to-top-button"
          aria-label="Scroll back to top"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.8 }}
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="fixed bottom-6 left-6 z-50 inline-flex h-12 w-12 items-center justify-center rounded-full border border-navy/15 bg-white/80 text-navy shadow-lg backdrop-blur-md transition-transform duration-300 hover:scale-110"
        >
          <ArrowUp className="h-5 w-5" />
        </motion.button>
      )}
    </AnimatePresence>
  );
};
